import { render } from "./AddToFavoritesModal.vue?vue&type=template&id=73b7c47b&scoped=true"
import script from "./AddToFavoritesModal.vue?vue&type=script&lang=js"
export * from "./AddToFavoritesModal.vue?vue&type=script&lang=js"

import "./AddToFavoritesModal.vue?vue&type=style&index=0&id=73b7c47b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b7c47b"]])

export default __exports__